import { z } from 'zod';

const InvestorBourseCodes = z.object({
  id: z.number(),
  isActive: z.boolean(),
  bourseCode: z.string().nullable(),
  type: z.number(),
});

const User = z.object({
  userId: z.number(),
  personageId: z.number(),
  userName: z.string().nullable(),
  userTitle: z.string().nullable(),
  userCode: z.string().nullable(),
  forceChangePassword: z.boolean(),
  isAgent: z.boolean(),
  isDealer: z.boolean(),
  isFutureAgent: z.boolean(),
  nationalCode: z.string().nullable(),
  image: z.string().nullable(),
  lastPasswordChange: z.boolean(),
  userLevel: z.number(),
  phone: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  permissions: z.string().array().nullable(),
  investorBourseCodes: InvestorBourseCodes.array(),
  bimCode: z.string(),
});

const UserBankAccountItem = z.object({
  accountCode: z.string(),
  accountId: z.number(),
  sheba: z.string(),
  title: z.string(),
});

const AgreementItem = z.object({
  agreementId: z.number(),
  agreementTitle: z.string().nullable(),
  documentUsageTypeTitle: z.string().nullable(),
  agreementPersianDate: z.string().nullable(),
  isApproved: z.boolean().nullable(),
  agreementDate: z.string(),
});

const AgreementQuery = AgreementItem.array();

const AgreementAttachment = z.object({
  title: z.string().nullable(),
  description: z.string().nullable(),
  agreementDate: z.string(),
  agreementPersianDate: z.string().nullable(),
  isEditableByUser: z.boolean(),
  attachment: z.string().nullable(),
  attachmentSize: z.number(),
  attachmentType: z.number(),
});

const AgreementApproveResponse = z.object({
  approve: z.boolean(),
});

type User = z.infer<typeof User> | null | undefined;
type UserBankAccountItem = z.infer<typeof UserBankAccountItem>;
type AgreementItem = z.infer<typeof AgreementItem>;
type AgreementQuery = z.infer<typeof AgreementQuery>;
type AgreementAttachment = z.infer<typeof AgreementAttachment>;
type AgreementApproveResponse = z.infer<typeof AgreementApproveResponse>;

export {
  User,
  UserBankAccountItem,
  AgreementItem,
  AgreementAttachment,
  AgreementApproveResponse,
  AgreementQuery,
};
